module.exports = {
  ...require(`../../firebase-config.development`),
  appId: '1:9929677373:web:dff12892526f171d',
  measurementId: 'G-W9R2YEEFK9',
};
